(function () {
  'use strict';

  var states = new WeakMap();

  function metresFromValue(value) {
    var match = String(value || '').trim().match(/^(\d+(?:[.,]\d+)?)\s*(?:m|metres?|meters?)$/i);
    return match ? parseFloat(match[1].replace(',', '.')) : null;
  }

  function requestedMetres(input) {
    var value = String(input.value || '').trim().replace(',', '.');
    if (!value) return null;
    if (!/^\d+(?:\.\d+)?$/.test(value)) return NaN;
    var number = parseFloat(value);
    return Number.isFinite(number) && number > 0 ? number : NaN;
  }

  function productArea(root) {
    return document.getElementById('Product-' + root.dataset.sectionId);
  }

  function variantPicker(root) {
    var area = productArea(root);
    return area ? area.querySelector('.product-block-variants variant-selects, .product-block-variants variant-radios') : null;
  }

  function variantWrapper(root) {
    var picker = variantPicker(root);
    return picker ? picker.closest('.product-block-variants') : null;
  }

  function formForRoot(root) {
    return document.getElementById(root.dataset.productFormId);
  }

  function labelForField(field) {
    var label = field.dataset.optionName || '';
    if (!label) {
      var node = field.querySelector('legend, label');
      label = node ? node.textContent : '';
    }
    return String(label).trim().toLowerCase();
  }

  function choicesForField(field) {
    return Array.prototype.slice.call(field.querySelectorAll('input[type="radio"], option')).map(function (choice) {
      return {
        node: choice,
        value: choice.value,
        metres: metresFromValue(choice.value),
        available: choice.dataset.variantAvailable !== 'false' && !choice.disabled
      };
    }).filter(function (choice) {
      return choice.metres !== null;
    });
  }

  function lengthField(picker) {
    var fields = Array.prototype.slice.call(picker.querySelectorAll('fieldset, .product-form-input-dropdown'));
    var named = fields.find(function (field) {
      var label = labelForField(field);
      return label === 'length' || label === 'size';
    });
    if (named && choicesForField(named).length) return named;
    return fields.find(function (field) {
      var choices = choicesForField(field);
      return choices.length > 1;
    }) || null;
  }

  function selectedValue(field) {
    var selected = field.querySelector('input[type="radio"]:checked, option:checked');
    return selected ? selected.value : '';
  }

  function resourceVariant(picker, choice) {
    if (!choice || !choice.id) return null;
    var script = picker.querySelector('script[type="application/json"][data-resource="' + CSS.escape(choice.id) + '"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (_error) {
      return null;
    }
  }

  function setChoice(field, choice) {
    if (!choice) return;
    if (choice.tagName === 'OPTION') {
      var select = choice.closest('select');
      if (!select) return;
      select.value = choice.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    choice.checked = true;
    choice.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function formatMoney(pennies, currency) {
    if (!Number.isFinite(Number(pennies))) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(Number(pennies) / 100);
    } catch (_error) {
      return '£' + (Number(pennies) / 100).toFixed(2);
    }
  }

  function replaceToken(template, token, value) {
    return String(template || '').split(token).join(value);
  }

  function chargeMessage(root, metres, variant) {
    var displayMetres = Number(metres) % 1 === 0 ? String(parseInt(metres, 10)) : String(metres);
    if (variant && Number(variant.price) > 0 && metres > 0) {
      var rate = formatMoney(Number(variant.price) / metres, root.dataset.currency);
      var message = replaceToken(root.dataset.messageCharge, '[metres]', displayMetres);
      return replaceToken(message, '[rate]', rate);
    }
    return replaceToken(root.dataset.messageChargeNoRate, '[metres]', displayMetres);
  }

  function showState(root, message, active) {
    var status = root.querySelector('[data-hol-switchboard-status]');
    var clear = root.querySelector('[data-hol-switchboard-clear]');
    if (status) status.textContent = message || '';
    if (clear) clear.hidden = !active;
    root.classList.toggle('is-active', Boolean(active));
  }

  function lockPicker(root, locked) {
    var picker = variantPicker(root);
    var wrapper = variantWrapper(root);
    if (root.hasAttribute('data-hol-sync-import')) {
      var field = picker ? lengthField(picker) : null;
      if (field) {
        field.inert = Boolean(locked);
        field.classList.toggle('hol-sync-length-locked', Boolean(locked));
      }
      return;
    }
    if (picker) {
      picker.inert = Boolean(locked);
      picker.setAttribute('aria-disabled', locked ? 'true' : 'false');
    }
    if (wrapper) wrapper.classList.toggle('hol-switchboard-variants-locked', Boolean(locked));
  }

  function clearValidity(input) {
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');
  }

  function setValidity(input, message) {
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', 'true');
  }

  function formatCutProperty(input) {
    var metres = requestedMetres(input);
    return Number.isFinite(metres) ? String(metres) + ' Metres' : '';
  }

  function restore(root, state, announce) {
    var picker = variantPicker(root);
    lockPicker(root, false);
    state.active = false;

    if (picker && state.snapshotValue) {
      var field = lengthField(picker);
      if (field && selectedValue(field) !== state.snapshotValue) {
        var snapshotChoice = Array.prototype.slice.call(field.querySelectorAll('input[type="radio"], option')).find(function (choice) {
          return choice.value === state.snapshotValue;
        });
        if (snapshotChoice) setChoice(field, snapshotChoice);
      }
    }

    state.snapshotValue = '';
    showState(root, announce ? root.dataset.messageRestored : '', false);
  }

  function applyLength(root) {
    var state = states.get(root);
    var input = root.querySelector('[data-hol-switchboard-cut-length]');
    if (!state || !input) return;

    var metres = requestedMetres(input);
    if (metres === null) {
      clearValidity(input);
      restore(root, state, state.active);
      return;
    }
    if (!Number.isFinite(metres)) {
      setValidity(input, root.dataset.messageUnavailable);
      return;
    }

    var picker = variantPicker(root);
    var field = picker ? lengthField(picker) : null;
    var choices = field ? choicesForField(field).filter(function (choice) { return choice.available; }) : [];
    if (!choices.length) {
      restore(root, state, false);
      setValidity(input, root.dataset.messageUnavailable);
      showState(root, root.dataset.messageUnavailable, false);
      return;
    }

    choices.sort(function (left, right) { return left.metres - right.metres; });
    var max = choices[choices.length - 1].metres;
    if (root.hasAttribute('data-hol-sync-import')) {
      var configuredMax = parseFloat(String(root.dataset.maxMtmMetres || '').replace(',', '.'));
      if (Number.isFinite(configuredMax) && configuredMax > 0) max = Math.min(max, configuredMax);
    }
    if (metres > max) {
      restore(root, state, false);
      var maxLabel = Number(max) % 1 === 0 ? String(parseInt(max, 10)) + 'm' : String(max) + 'm';
      var limitMessage = replaceToken(root.dataset.messageLimit, '[max]', maxLabel);
      setValidity(input, limitMessage);
      showState(root, limitMessage, false);
      return;
    }

    var target = choices.find(function (choice) { return choice.metres >= metres; });
    if (!target) return;

    clearValidity(input);
    if (!state.active) state.snapshotValue = selectedValue(field);
    var currentValue = selectedValue(field);
    var variant = resourceVariant(picker, target.node);
    if (currentValue !== target.value) setChoice(field, target.node);
    state.active = true;
    lockPicker(root, true);
    showState(root, chargeMessage(root, target.metres, variant), true);
  }

  function guardSubmit(root, event) {
    var input = root.querySelector('[data-hol-switchboard-cut-length]');
    if (!input) return;
    applyLength(root);
    if (!input.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.reportValidity();
      input.focus();
    }
  }

  function mountGloboOptions(root) {
    var area = productArea(root);
    var slot = root.querySelector('[data-hol-switchboard-globo-slot]');
    if (!area || !slot || root.querySelector('[data-hol-cable-options]')) return false;
    var containers = Array.prototype.slice.call(area.querySelectorAll('.gpo-container'));
    var mounted = false;
    var hasVisibleOptions = false;
    containers.forEach(function (container) {
      if (!container.querySelector('.gpo-app .gpo-element')) return;
      container.querySelectorAll('.gpo-element').forEach(function (element) {
        var input = element.querySelector('[data-field-name]');
        if (input && String(input.dataset.fieldName).trim().toLowerCase() === 'required cut length' && !element.querySelector('[data-addon-price]')) {
          element.hidden = true;
          element.setAttribute('aria-hidden', 'true');
          element.querySelectorAll('input, select, textarea').forEach(function (control) { control.disabled = true; });
        } else if (!element.hidden) hasVisibleOptions = true;
      });
      var block = container.closest('.shopify-app-block') || container;
      if (!slot.contains(block)) {
        var sourceParent = block.parentElement;
        block.querySelectorAll('input, select, textarea, button').forEach(function (control) {
          if (control.form && !control.hasAttribute('form') && control.form.id) control.setAttribute('form', control.form.id);
        });
        slot.appendChild(block);
        if (sourceParent && sourceParent.classList.contains('product-info-secondary') && !sourceParent.children.length) sourceParent.classList.add('hol-switchboard-gpo-source-empty');
      }
      container.querySelectorAll('.gpo-dropdown').forEach(function (dropdown, index) {
        var button = dropdown.querySelector('.dropdown-button');
        var list = dropdown.querySelector('.dropdown-list');
        if (!button || !list || button.dataset.holGloboReady === 'true') return;
        button.dataset.holGloboReady = 'true';
        list.id = list.id || 'hol-globo-options-' + root.dataset.sectionId + '-' + index;
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-controls', list.id);
        var label = dropdown.closest('.gpo-element').querySelector('.gpo-label');
        if (label) button.setAttribute('aria-label', label.textContent.trim());
        function sync() {
          var expanded = dropdown.classList.contains('expanded');
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          list.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        }
        sync();
        button.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); button.click(); }
          if (event.key === 'Escape' && dropdown.classList.contains('expanded')) { event.preventDefault(); button.click(); }
        });
        new MutationObserver(sync).observe(dropdown, { attributes: true, attributeFilter: ['class'] });
      });
      mounted = true;
    });
    if (mounted) { slot.hidden = !hasVisibleOptions; root.classList.toggle('has-globo-options', hasVisibleOptions); }
    return mounted;
  }

  function observeGloboOptions(root, state) {
    if (root.querySelector('[data-hol-cable-options]')) return;
    if (mountGloboOptions(root)) {
      if (state.globoObserver) state.globoObserver.disconnect();
      if (state.globoTimer) window.clearTimeout(state.globoTimer);
      state.globoObserver = null;
      state.globoTimer = null;
      return;
    }
    if (state.globoObserver) return;
    var area = productArea(root);
    if (!area) return;
    var observer = new MutationObserver(function () {
      if (!root.isConnected || mountGloboOptions(root)) {
        observer.disconnect(); window.clearTimeout(state.globoTimer); state.globoObserver = null; state.globoTimer = null;
      }
    });
    state.globoObserver = observer;
    observer.observe(area, { childList: true, subtree: true });
    state.globoTimer = window.setTimeout(function () { observer.disconnect(); state.globoObserver = null; state.globoTimer = null; }, 15000);
  }

  function initRoot(root) {
    if (states.has(root)) { observeGloboOptions(root, states.get(root)); return; }
    var input = root.querySelector('[data-hol-switchboard-cut-length]');
    var clear = root.querySelector('[data-hol-switchboard-clear]');
    var form = formForRoot(root);
    if (!input || !form) return;

    var state = { active: false, snapshotValue: '', unsubscribe: null };
    states.set(root, state);
    observeGloboOptions(root, state);

    input.addEventListener('input', function () { applyLength(root); });
    input.addEventListener('change', function () { applyLength(root); });
    clear.addEventListener('click', function () {
      input.value = '';
      clearValidity(input);
      restore(root, state, true);
      input.focus();
    });
    form.addEventListener('submit', function (event) { guardSubmit(root, event); }, true);
    form.addEventListener('formdata', function (event) {
      var displayValue = formatCutProperty(input);
      if (displayValue) event.formData.set('properties[Cut Length]', displayValue);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      state.unsubscribe = subscribe(PUB_SUB_EVENTS.productVariantChange, function (event) {
        if (!event || String(event.sectionId) !== String(root.dataset.sectionId)) return;
        observeGloboOptions(root, state);
        if (state.active) {
          if (root.hasAttribute('data-hol-sync-import')) applyLength(root);
          else lockPicker(root, true);
        }
      });
    }

    if (root.hasAttribute('data-hol-sync-import') && window.customElements) {
      customElements.whenDefined('media-gallery').then(function () {
        var picker = variantPicker(root);
        if (picker && picker.currentVariant && picker.updateMedia) picker.updateMedia();
      });
    }

    if (requestedMetres(input) !== null) applyLength(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-hol-switchboard-customise]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
